require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/core-js/library/modules/es7.symbol.observable.js
// module id = 298
// module chunks = 0